import Vue from 'vue';
import buefy from 'buefy';
import 'buefy/dist/buefy.css';
import { i18n } from 'plugins/vue-i18n';
import InfiniteLoading from 'vue-infinite-loading';
import VueGtag from 'vue-gtag';
import firebase from 'plugins/firebase';
import { firestorePlugin } from 'vuefire';
import VueCookies from 'vue-cookies';
import FullpageModal from 'vue-fullpage-modal';
import App from './App.vue';
import store from './store';
import router from './router';

Vue.config.productionTip = false;
Vue.use(buefy);
Vue.use(() => import('vue-axios'), () => import('axios'));
Vue.use(firestorePlugin);
Vue.use(FullpageModal);
Vue.component('foldable', () => import('vue-foldable'));
Vue.component('videoItem', () => import('components/VideoItem.vue'));
Vue.use(InfiniteLoading, { /* options */ });

Vue.use(VueGtag, {
  config: { id: process.env.VUE_APP_GA_RESOURCE_STREAM_ID },
  bootstrap: false,
});

Vue.use(() => import('vue-meta'), {
  // optional pluginOptions
  refreshOnceOnNavigation: true,
});

Vue.use(VueCookies);

// TODO: need to refactor
Vue.prototype.$firebase = firebase;

new Vue({
  router,
  store,
  i18n,
  // created() { i18n.locale = localStorage.getItem('lang'); },
  render: (h) => h(App),
}).$mount('#app');
